import { render, staticRenderFns } from "./ExpensesTypes.vue?vue&type=template&id=cb0000ca&"
import script from "./ExpensesTypes.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports